import ReactDOM from "react-dom";

const CustomModal = ({ children, isVisible = false }) => {
	if (!isVisible) return <></>;
	return ReactDOM.createPortal(
		<div className="fixed z-50 w-full h-full top-0 left-0 flex justify-center items-center" style={{ backdropFilter: `blur(8px)` }}>
			{children}
		</div>,
		document.getElementById("modal")
	);
};

export default CustomModal;
